export { default as database } from "./database";
import { default as arq } from "./offlineRequest";

//expose the 2 common apis as default export
const api = {
	offlinerequest: arq
}

export default api;
export const offlinerequest = arq;